$( document ).ready(function() {

  $('.marquee')
  .marquee({
      //If you wish to always animate using jQuery
      allowCss3Support: true
      , //works when allowCss3Support is set to true - for full list see http://www.w3.org/TR/2013/WD-css3-transitions-20131119/#transition-timing-function
      css3easing: 'linear'
      , //requires jQuery easing plugin. Default is 'linear'
      easing: 'linear'
      , //pause time before the next animation turn in milliseconds
      delayBeforeStart: 1000
      , //'left', 'right', 'up' or 'down'
      direction: 'left'
      , //true or false - should the marquee be duplicated to show an effect of continues flow
      duplicated: true
      , //speed in milliseconds of the marquee in milliseconds
      duration: 30000
      , //gap in pixels between the tickers
      gap: 0
      , //on cycle pause the marquee
      pauseOnCycle: false
      , //on hover pause the marquee - using jQuery plugin https://github.com/tobia/Pause
      pauseOnHover: false
      , //the marquee is visible initially positioned next to the border towards it will be moving
      startVisible: true
  });
    
  $(".accordion").on("click", ".accordion__title", function() {
      let $title = $(this);
      let $card = $title.closest(".accordion__card"); // get parent card

      // toggle active on clicked title + parent card
      $title.toggleClass("active");
      $card.toggleClass("active");

      // toggle content
      $title.next().slideToggle();

      // close other accordions
      $(".accordion__content").not($title.next()).slideUp(300);
      $(".accordion__title").not($title).removeClass("active");
      $(".accordion__card").not($card).removeClass("active");
  });
  var swiper = new Swiper(".testimonial-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
  $('.collection_tab_nav .tab_nav__item:first-child a').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();
  $('.collection_tab_nav .tab_nav__item a').click(function(){
      $('.collection_tab_nav .tab_nav__item a').removeClass('active');
      $(this).addClass('active');
      $('.tab-content').hide();
      
      var activeTab = $(this).attr('href');
      $(activeTab).fadeIn();
      return false;
  });
  var swiper = new Swiper(".collection_tab__slider", {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20, 
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
      breakpoints: {
      // When window width is >= 480px
      480: {
        slidesPerView: 2
      },
      // When window width is >= 768px
      749: {
        slidesPerView: 3
      },
      // When window width is >= 1280px
      1280: {
        slidesPerView: 4
      }
    },
  });
  var swiper = new Swiper(".collection_tab__slider", {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20, 
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
      breakpoints: {
      // When window width is >= 480px
      480: {
        slidesPerView: 2
      },
      // When window width is >= 768px
      749: {
        slidesPerView: 3
      },
      // When window width is >= 1280px
      1280: {
        slidesPerView: 4
      }
    },
  });
  var swiper = new Swiper(".video-reels-swiper", {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20, 
    pagination: {
      el: '.swiper-pagination', 
      clickable:true
    },
      breakpoints: {
      // When window width is >= 480px
      480: {
        slidesPerView: 2
      },
      // When window width is >= 768px
      749: {
        slidesPerView: 3
      },
      // When window width is >= 1280px
      1280: {
        slidesPerView: 4
      }
    },
  });  
  $(".mute-toggle").on("click", function(){
    var $button = $(this);
    var $video = $button.siblings(".reel_video").get(0);

    if($video.muted){
      // Mute all videos first
      $(".reel_video").prop("muted", true);
      $(".mute-toggle .mute-icon").removeClass("hidden");
      $(".mute-toggle .unmute-icon").addClass("hidden");

      // Unmute current video
      $video.muted = false;
      $button.find(".mute-icon").addClass("hidden");
      $button.find(".unmute-icon").removeClass("hidden");
    } else {
      // Mute this video again
      $video.muted = true;
      $button.find(".mute-icon").removeClass("hidden");
      $button.find(".unmute-icon").addClass("hidden");
    }
  }); 

  // Run once at page load for the first tab
  updateViewAllBtn();

  // When tab changes (click on nav item)
  $('.collection_tab_nav .tab_nav__item a').on('click', function (e) {
    e.preventDefault();

    // Remove active class from all and add to clicked
    $('.collection_tab_nav .tab_nav__item a').removeClass('active');
    $(this).addClass('active');

    // Update the View All button with new tab's URL
    updateViewAllBtn();
  });

  function updateViewAllBtn() {
    // Get currently active tab's URL
    var activeUrl = $('.collection_tab_nav .tab_nav__item a.active').data('url');

    if (activeUrl) {
      $('#collection-view-all-btn').attr('href', activeUrl);
    }
  }
  if (window.innerWidth < 750) {
    $(".footer__blocks-wrapper").on("click", ".footer-block__heading", function () {
        let $this = $(this);
        let $content = $this.next(".footer-block__details-content");

        // Close other siblings
        $this.closest(".footer__blocks-wrapper")
            .find(".footer-block__details-content")
            .not($content)
            .slideUp()
            .prev(".footer-block__heading")
            .removeClass("active");

        // Toggle clicked one
        $this.toggleClass("active");
        $content.stop(true, true).slideToggle();
    });
  }  

  $( ".product_sticky__add2cart" ).on( "click", function() {
    $( ".product-form__submit" ).trigger( "click" );
  });
  $(window).on("scroll", () => {
    $(".product-form").each(function() {
      //var className = $(this).attr("touching")
      var offset = $(this).offset().top - $(window).scrollTop() - 0;
      if (offset <= 0) {
        $('.product_sticky__cart').addClass('active')
      } else {
        $('.product_sticky__cart').removeClass('active')
      }
    })
  }).trigger("scroll")
  
  handleDropdownChange = (e) => {
    if (event.target.matches('input[type="radio"]')) {      
      const swatchInputId = e.target.id;      
      const swatchLabel = document.querySelector(`input[id="${swatchInputId}"]`);
      if (swatchLabel) {
            // 1. Extract the variant data from the label (which includes the data- attributes we added)
            const variantId = swatchLabel.getAttribute('data-variant-id');
            const variantPrice = swatchLabel.getAttribute('data-variant-price'); // Price in dollars/units (e.g., 99.00)
            const isAvailable = swatchLabel.getAttribute('data-available') === 'true';
            const newRelativeImageURL = swatchLabel.getAttribute('data-variant-img');

            // 2. Find the Quick Add button associated with this product card
            const productCard = e.target.closest(".card-wrapper") || e.target.closest("product-card");
            // const quickAddButton = productCard ? productCard.querySelector(".card__button a") : null;     
            const quickAddButton = productCard ? productCard.querySelector(".card__button button") : null;     
            const mediaImages = productCard.querySelectorAll(".media img");  
            console.log("mediaImagesmediaImages", mediaImages)
            const media  = mediaImages[0];
            const existingSrcset = media ? media.getAttribute('srcset') : null;          
            const srcPath = media.src;
            const basePathIndex = srcPath.lastIndexOf('/cdn/shop/'); 
            if (basePathIndex > -1) {
              const oldFileMatch = existingSrcset.match(/products\/([^? ]+)\?/);
              const oldImagePath = 'products/' + oldFileMatch[1];
              const newSrcset = existingSrcset.replace(new RegExp(oldImagePath, 'g'), newRelativeImageURL);              
              const baseURL = srcPath.substring(0, basePathIndex + 10);
              const relativePart = newRelativeImageURL.startsWith('shop/') 
                    ? newRelativeImageURL.substring('shop/'.length) 
                    : newRelativeImageURL;
                // Assuming the relative part is what follows '/cdn/shop/'
              const newFullImageURL = baseURL + relativePart;                
              media.src = newFullImageURL;
              media.srcset = newSrcset;
            }
            if (quickAddButton) {
                // 3. Update the Quick Add button's data
                if (variantId && isAvailable) {
                  // let currentHref = quickAddButton.getAttribute('href'); 
                  // const cleanPath = currentHref.split('?')[0];
                  // const newHref = `${cleanPath}?variant=${variantId}`;
                  // quickAddButton.setAttribute('href', newHref);         
                  quickAddButton.setAttribute('price', variantPrice);         
                  quickAddButton.setAttribute('variant-id', variantId);         
                  
            }
        }
      }
    } 
  };

  document.addEventListener("change", handleDropdownChange);

  const add_to_cart = document.querySelectorAll(".card__button .btn-add-to-cart");
  add_to_cart.forEach(btn => {
    
    btn.addEventListener("click", () => {
      console.log("add_to_cart", btn)
      let variantId = btn.getAttribute("variant-id");
      let price = btn.getAttribute("price");
      console.log("add_to_cart", price, variantId);

      let formData = { items: [ { id: variantId, price: price }] };

      fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then((response)=> {
          console.log("response", response);
          // setTimeout(() => {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true, // Make sure it bubbles up
              detail: {
                cart: response // Pass the updated cart object
              }
            }));
            handleFloCartBtn();
          // }, 1000);
          
        })
      
      
    })
  });
  const variantInput = document.querySelector("form[action*='/cart/add'] [name='id']");
  if (!variantInput) return;

  // Initial variant
  fetchVariantData(variantInput.value);

  // Listen for changes
  variantInput.addEventListener("change", () => {
    fetchVariantData(variantInput.value);
  });

  function fetchVariantData(variantId) {
    fetch(`${window.location.pathname}.js`)
      .then((res) => res.json())
      .then((product) => {
        const variant = product.variants.find((v) => v.id == variantId);
        if (!variant) return;

        // Selectors
        let s_price = document.querySelector("div[id^='price-template--'][id$='__main'] .price__sale s");
        let sale_price = document.querySelector("div[id^='price-template--'][id$='__main'] .price__sale .price-item--sale");
        let dis_price = document.querySelector("div[id^='price-template--'][id$='__main'] .product-discount");
        
        //sticky
        const regularPriceEl = document.querySelector(".product_sticky__price .price__sale s"); 
        const salePriceEl = document.querySelector(".product_sticky__price .price__sale .price-item--sale");
        const discountEl = document.querySelector(".product_sticky__price .product-discount");

        // Regular Price (Compare at Price)
        if (regularPriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            regularPriceEl.textContent = s_price.textContent.trim();
            regularPriceEl.style.display = "inline"; // show it
          } else {
            regularPriceEl.textContent = "";
            regularPriceEl.style.display = "none"; // hide if no compare price
          }
        }

        // Sale Price (Actual price)
        if (salePriceEl) {
          salePriceEl.textContent = sale_price.textContent.trim();
        }

        // Discount %
        if (discountEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            discountEl.textContent = dis_price.textContent.trim();
            discountEl.style.display = "inline";
          } else {
            discountEl.textContent = "";
            discountEl.style.display = "none";
          }
        }
      });
  }



}); 